var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApoio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_15212",
    "data-name": "Grupo 15212",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.527,
    height: 44.527,
    viewBox: "0 0 44.527 44.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15073",
    "data-name": "Grupo 15073"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 22.263,
    cy: 22.263,
    r: 22.263,
    fill: "#009bde"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "support_agent_FILL0_wght400_GRAD0_opsz48",
    d: "M94.433-813.355a1.071,1.071,0,0,1-.791-.321,1.084,1.084,0,0,1-.319-.8,1.062,1.062,0,0,1,.319-.789,1.082,1.082,0,0,1,.791-.315h11.472v-11.25a9.637,9.637,0,0,0-.925-4.126,11.867,11.867,0,0,0-2.479-3.5,12.348,12.348,0,0,0-3.553-2.424,9.925,9.925,0,0,0-4.145-.907,9.925,9.925,0,0,0-4.145.907,12.348,12.348,0,0,0-3.553,2.424,11.867,11.867,0,0,0-2.479,3.5,9.637,9.637,0,0,0-.925,4.126v8.29a.716.716,0,0,1-.213.527.716.716,0,0,1-.527.213,2.851,2.851,0,0,1-2.091-.87,2.851,2.851,0,0,1-.87-2.091v-2.961a2.757,2.757,0,0,1,.407-1.5,3.25,3.25,0,0,1,1.073-1.055l.111-1.961a13.426,13.426,0,0,1,1.536-4.885,13,13,0,0,1,3-3.7,13.471,13.471,0,0,1,4.034-2.35A13.22,13.22,0,0,1,94.8-840a13.323,13.323,0,0,1,4.681.833A13.033,13.033,0,0,1,103.5-836.8a13.517,13.517,0,0,1,2.979,3.7,13.217,13.217,0,0,1,1.536,4.83l.111,1.924a2.648,2.648,0,0,1,1.073.981,2.625,2.625,0,0,1,.407,1.425v3.4a2.6,2.6,0,0,1-.407,1.443,2.69,2.69,0,0,1-1.073.962v2.554a2.138,2.138,0,0,1-.652,1.568,2.138,2.138,0,0,1-1.568.652Zm-4.071-10.732a1.065,1.065,0,0,1-.777-.333,1.086,1.086,0,0,1-.333-.8,1.026,1.026,0,0,1,.333-.777,1.119,1.119,0,0,1,.8-.315,1.048,1.048,0,0,1,.777.319,1.083,1.083,0,0,1,.315.791,1.088,1.088,0,0,1-.319.777A1.052,1.052,0,0,1,90.362-824.087Zm8.882,0a1.065,1.065,0,0,1-.777-.333,1.086,1.086,0,0,1-.333-.8,1.026,1.026,0,0,1,.333-.777,1.119,1.119,0,0,1,.8-.315,1.048,1.048,0,0,1,.777.319,1.083,1.083,0,0,1,.315.791,1.088,1.088,0,0,1-.319.777A1.052,1.052,0,0,1,99.244-824.087Zm-13.286-1.924a8.488,8.488,0,0,1,.611-3.96,9.161,9.161,0,0,1,2.035-3.016,8.958,8.958,0,0,1,2.942-1.906,8.911,8.911,0,0,1,3.331-.666,8.014,8.014,0,0,1,5.662,2.128,9.008,9.008,0,0,1,2.813,5.311,10.7,10.7,0,0,1-6.125-1.869,12.316,12.316,0,0,1-4.089-4.755,11.819,11.819,0,0,1-2.5,5.311A11.516,11.516,0,0,1,85.958-826.011Z",
    transform: "translate(-72.54 847.863)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApoio);
export default __webpack_public_path__ + "static/media/apoio.9093754ebfe5e57c0a684b60444b1602.svg";
export { ForwardRef as ReactComponent };